// extracted by mini-css-extract-plugin
module.exports = {"notificationContainer":"Notification_notificationContainer__tNtBr","notifications":"Notification_notifications__1PW5t"};